import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const handleMouseEnter = (menu) => {
    setActiveDropdown(menu);
  };

  const handleMouseLeave = () => {
    setActiveDropdown(null);
  };

  // Close any open dropdown on route change
  useEffect(() => {
    setActiveDropdown(null);
    setMobileMenuOpen(false);
  }, [location.pathname]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen((prev) => !prev);
  };

  const serviceItems = [
    { name: 'Hardware Installation', path: '/services/hardware-installation' },
    { name: 'Network Setup & Configuration', path: '/services/network-setup' },
    { name: 'System Maintenance', path: '/services/system-maintenance' },
    { name: 'Technical Support', path: '/services/technical-support' },
    { name: 'Server Management', path: '/services/server-management' },
    { name: 'Data Recovery', path: '/services/data-recovery' },
    { name: 'Security Solutions', path: '/services/security-solutions' },
    { name: 'Cloud Services', path: '/services/cloud-services' }
  ];

  const ourStoryItems = [
    { name: 'About Us', path: '/about' },
    { name: 'Certificates', path: '/certificates' },
    { name: 'Careers', path: '/careers' }
  ];

  const loginItems = [
    { name: 'Mail', href: 'https://sysmaco.fortiddns.com:10443/remote/login?lang=en' },
    { name: 'TimeSheet', href: 'https://apps.timeclockwizard.com/Login?Subdomain=sysmaco' }
  ];

  return (
    <>
      {/* Mobile Menu Overlay */}
      <div
        className={`mobile-menu-overlay ${mobileMenuOpen ? 'show' : ''}`}
        onClick={toggleMobileMenu}
      />

      {/* Mobile Menu Container */}
      <div className={`mobile-menu-container ${mobileMenuOpen ? 'open' : ''}`}>
        <button
          className="mobile-menu-close"
          onClick={toggleMobileMenu}
          aria-label="Close menu"
        >
          ✕
        </button>
        <div className="mobile-menu-content">
          <nav className="mobile-nav">
            <ul className="nav-list">
              {/* Services Menu */}
              <li
                className="nav-item dropdown"
                onMouseEnter={() => handleMouseEnter('services')}
                onMouseLeave={handleMouseLeave}
              >
                <span
                  className="nav-link"
                  onClick={() => setActiveDropdown(activeDropdown === 'services' ? null : 'services')}
                >
                  Services
                  <span className="dropdown-arrow">▼</span>
                </span>
                {activeDropdown === 'services' && (
                  <div className="dropdown-menu">
                    {serviceItems.map((item, index) => (
                      <Link
                        key={index}
                        to={item.path}
                        className="dropdown-item"
                        onClick={() => {
                          setActiveDropdown(null);
                          setMobileMenuOpen(false);
                        }}
                      >
                        {item.name}
                      </Link>
                    ))}
                  </div>
                )}
              </li>

              {/* Our Story Menu */}
              <li
                className="nav-item dropdown"
                onMouseEnter={() => handleMouseEnter('story')}
                onMouseLeave={handleMouseLeave}
              >
                <span
                  className="nav-link"
                  onClick={() => setActiveDropdown(activeDropdown === 'story' ? null : 'story')}
                >
                  Our Story
                  <span className="dropdown-arrow">▼</span>
                </span>
                {activeDropdown === 'story' && (
                  <div className="dropdown-menu">
                    {ourStoryItems.map((item, index) => (
                      <Link
                        key={index}
                        to={item.path}
                        className="dropdown-item"
                        onClick={() => {
                          setActiveDropdown(null);
                          setMobileMenuOpen(false);
                        }}
                      >
                        {item.name}
                      </Link>
                    ))}
                  </div>
                )}
              </li>

              {/* Contact Us */}
              <li className="nav-item">
                <Link
                  to="/contact"
                  className="nav-link"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Contact Us
                </Link>
              </li>

              {/* Get a Quote */}
              <li className="nav-item">
                <Link
                  to="/quote"
                  className="nav-link btn-tertiary"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  <div className="button-flex">
                    <div>Get a Quote</div>
                    <div className="btn-tertiary-arrow-2 w-embed">
                      <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
                        <path d="M5 12h12m0 0-5-5m5 5-5 5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                  </div>
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <header className={`header ${mobileMenuOpen ? 'mobile-open' : ''}`}>
        <div className='top-nav-container-2 w-container'>
        {/* Contact Information */}
        <div className="top-nav-left">
          <span className="nav-contact-info">
            📞 <a href='tel:+91 (33) 35531279' >+91 (33) 35531279</a> | 📧 <a href="mailto:info@sysmaco.in">info@sysmaco.in</a> | 🕒 Mon-Fri 10:30 AM - 6:30 PM
          </span>
        </div>
        
        {/* Social Media Links */}
        <div className="top-nav-right">
          <div className="social-links">
          <a href="https://wa.me/919831024375" target="_blank" rel="noopener noreferrer" className="social-link">
              <span className="whatsapp-icon" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" focusable="false">
                  <path fill="#25D366" d="M12 2c5.5 0 10 4.5 10 10 0 5.52-4.48 10-10 10-1.76 0-3.41-.46-4.84-1.28L4 22l1.33-3.09C4.48 17.41 4 15.76 4 14 4 6.5 6.5 2 12 2z"/>
                  <path fill="#fff" d="M16.54 13.37c-.23-.12-1.35-.67-1.56-.74-.21-.08-.36-.12-.51.12-.15.23-.59.74-.72.9-.13.15-.27.17-.5.06-.23-.12-.98-.36-1.87-1.14-.69-.61-1.14-1.36-1.27-1.59-.13-.23-.01-.36.1-.48.1-.1.23-.27.35-.4.12-.13.15-.23.23-.38.08-.15.04-.28-.02-.4-.06-.12-.51-1.23-.7-1.69-.18-.44-.37-.38-.51-.39-.13-.01-.28-.01-.43-.01-.15 0-.4.06-.61.28-.21.23-.8.78-.8 1.9 0 1.12.82 2.2.93 2.35.12.15 1.62 2.48 3.93 3.48.55.24.98.38 1.31.49.55.18 1.05.15 1.45.09.44-.07 1.35-.55 1.54-1.08.19-.53.19-.98.13-1.08-.06-.1-.21-.16-.44-.28z"/>
                </svg>
              </span>
              WhatsApp
            </a>
            <span className="separator">|</span>
            <a href="https://instagram.com/sysmaco" target="_blank" rel="noopener noreferrer" className="social-link">
              📷 Instagram
            </a>
            <span className="separator">|</span>
            <a href="https://facebook.com/sysmaco" target="_blank" rel="noopener noreferrer" className="social-link">
              📘 Facebook
            </a>
            <span className="separator">|</span>
            <a href="https://linkedin.com/company/sysmaco" target="_blank" rel="noopener noreferrer" className="social-link">
              💼 LinkedIn
            </a>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="header-content">
          {/* Logo */}
          <div className="logo">
            <Link to="/" className="logo-link">
              <img
                src="/images/sysmaco-symbol.png"
                alt="Sysmaco Logo"
                className="logo-image"
              />
            </Link>
          </div>

          {/* Mobile Hamburger Toggle */}
          <button
            className="mobile-menu-toggle"
            aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
            aria-expanded={mobileMenuOpen}
            onClick={toggleMobileMenu}
          >
            <svg
              viewBox="0 0 24 24"
              width="24"
              height="24"
              aria-hidden="true"
              focusable="false"
              className={`hamburger-icon ${mobileMenuOpen ? 'open' : ''}`}
            >
              <line
                x1="3"
                y1="6"
                x2="21"
                y2="6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <line
                x1="3"
                y1="12"
                x2="21"
                y2="12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                className="middle-line"
              />
              <line
                x1="3"
                y1="18"
                x2="21"
                y2="18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>

          {/* Navigation Menu - Desktop Only */}
          <nav className="nav">
            <ul className="nav-list">
              {/* Services Menu */}
              <li
                className="nav-item dropdown"
                onMouseEnter={() => handleMouseEnter('services')}
                onMouseLeave={handleMouseLeave}
              >
                <span className="nav-link">
                  Services
                  <span className="dropdown-arrow">▼</span>
                </span>
                {activeDropdown === 'services' && (
                  <div className="dropdown-menu">
                    {serviceItems.map((item, index) => (
                      <Link key={index} to={item.path} className="dropdown-item" onClick={() => setActiveDropdown(null)}>
                        {item.name}
                      </Link>
                    ))}
                  </div>
                )}
              </li>

              {/* Our Story Menu */}
              <li
                className="nav-item dropdown"
                onMouseEnter={() => handleMouseEnter('story')}
                onMouseLeave={handleMouseLeave}
              >
                <span className="nav-link">
                  Our Story
                  <span className="dropdown-arrow">▼</span>
                </span>
                {activeDropdown === 'story' && (
                  <div className="dropdown-menu">
                    {ourStoryItems.map((item, index) => (
                      <Link key={index} to={item.path} className="dropdown-item" onClick={() => setActiveDropdown(null)}>
                        {item.name}
                      </Link>
                    ))}
                  </div>
                )}
              </li>

              {/* Contact Us */}
              <li className="nav-item">
                <Link to="/contact" className="nav-link">Contact Us</Link>
              </li>

              {/* Get a Quote */}
              <li className="nav-item">
                <Link to="/quote" className="nav-link btn-tertiary" >
                  <div className="button-flex">
                    <div>Get a Quote</div>
                    <div className="btn-tertiary-arrow-2 w-embed">
                      <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
                        <path d="M5 12h12m0 0-5-5m5 5-5 5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                  </div>
                </Link>
              </li>
            </ul>
          </nav>

          {/* Login Button with Dropdown - Desktop */}
          <div
            className="auth-section login-dropdown"
            onMouseEnter={() => handleMouseEnter('login')}
            onMouseLeave={handleMouseLeave}
          >
            <button className="btn btn-primary login-btn" aria-haspopup="true" aria-expanded={activeDropdown === 'login'}>
              Employee Login <span className="dropdown-arrow">▼</span>
            </button>
            {activeDropdown === 'login' && (
              <div className="dropdown-menu">
                {loginItems.map((item, index) => (
                  <a
                    key={index}
                    className="dropdown-item"
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.name}
                  </a>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
    </>
  );
};

export default Header;
